import * as feedActions from './feed/actions'

// eslint-disable-next-line
export const actions = { feed: feedActions }



// WEBPACK FOOTER //
// ./src/features/Ads/data/actions.js